import './App.css';
import SearchWeather from './component/SearchWeather';


function App() {
  return (
   <div>
      <SearchWeather/>
   </div>
  );
}

export default App;
